module.exports = __webpack_public_path__ + "img/02.18f44761.jpg";